export default function ContractCPE({ isChecked, handleCheckboxChange, handleNextButtonClick }) {
    return (
        <div className="container mb100 mt100">
                    <div className="beckertitlename mb100 mt100">Becker CPE方案</div>
                    <div class="card w-75 p-5 m-auto">
                    <h5 class="card-title text-black text-center">Becker CPE 方案購買須知與同意事項 (請務必詳閱)</h5>
                    <div className="br mb-5 mt-3"></div>
                    <div class="card-body">
                    <p class="card-text m-auto">
                        <div>
                            <ol>
                                <li>
                                購買方案者，須填妥本訂購單資料表，完整審閱同意事項後，完成付費，方符合訂購程序。繳費前，請先確認購買產品內容與費用。
                                <ul>
                                    <li>購買前請確認完整審閱此份購買須知與相關規定，審閱期已達五日。</li>
                                    <li>本商品屬於行政院公告之「通訊交易解除權合理例外情事適用準則」第2條可排除消費者保護法第19條七日解除權之合理例外情事者，惟若商品未經領取、未開始參加課程、且未登入任何產品內含學習帳號時，購買後七日猶豫期內得要求退費。</li>
                                    <li>購買者於本線上報名及訂購流程中勾選「同意」並完成購買程序時，即表示已完整審閱並確認同意本契約全部條款內容，並同意以系統依其所填載之中文姓名自動產生之電子簽名（屬電子形式之姓名印記，非本人親筆簽名）作為本人簽名及用印之正式意思表示。購買者確認該電子簽名係其真意表示，並同意不得以非親筆簽名或電子形式為由否認其法律效力。系統並將依該電子簽名自動生成並成立本購買契約書，其效力與經購買者親筆簽名之書面契約相同，對雙方均具法律拘束力。</li>
                                    <li>教材一經領取或帳號登入後，恕不退費亦不得要求暫停效期。</li>
                                    <li>學員領取帳號後，應妥善保管其登入密碼，確保不為他人得知，利用學員帳號密碼登入學習帳號，將推定為學員本人之行為。因非可歸責於 Becker Taiwan (捷進)之事由導致登入密碼外洩時， 學員應儘速通知，Becker Taiwan (捷進)除提供必要協助外，不負任何法律上責任。</li>
                                    <li>購買方案者保證為完全行為能力人或已得法定代理人同意之限制行為能力人。</li>
                                    <li>
                                    作業系統需求：
                                    <ul>
                                        <li>Windows：Windows 7以上</li>
                                        <li>MacOS：10以上</li>
                                        <li>iOS：13以上（限App）</li>
                                        <li>Android：8以上（限App）</li>
                                    </ul>
                                    </li>
                                    <li>
                                    網路需求：
                                    <ul>
                                        <li>寬頻下載速度 20Mbps 以上</li>
                                        <li>不建議使用公共、社區型或無線網路</li>
                                        <li>動裝置限定使用 APP 版觀看中文課程。</li>
                                        <li>
                                        不建議無線、社區型、有線電視台網路、公共免費網路，可能造成無法正常驗證登入或個人帳號密碼資料外洩。<br />
                                        ※注意事項：行動裝置限定使用APP版觀看課程。<br />
                                        ※其餘未列示之軟硬體或系統，恕不保證其觀看學習品質
                                        </li>
                                    </ul>
                                    </li>
                                </ul>
                                </li>

                                <li>
                                學員資料表 E-mail 信箱資訊，有效期限必須達十二個月以上，購買後請自行定期收信，本軟體服務及一切相關資訊將以該 E-mail 信箱為聯繫方式，若因學員未定期收信導致權益受影響，學員應自負其責。
                                </li>
                                <li>
                                Becker CPE 系列方案為美國原版教材軟體，方案內含之教材、課程、服務皆限購買者個人使用，學員應遵循 Becker 服務政策，且嚴禁任何形式之轉售、轉贈、轉讓及分享，若經發現，學員應賠償購買總價10倍之懲罰性違約金及損害賠償。
                                <ul>
                                    <li>Becker CPE Select 一年方案之使用權限效期以清款購買當日起算後之十二個月後終止。</li>
                                    <li>Becker CPE Essentials 90天方案之使用權限效期以清款購買當日起算後之十二個月後終止。</li>
                                    <li>為提升服務品質及確保學員正確使用本教材，Becker Professional Education 與 Becker Taiwan (捷進) 將蒐集、處理並分析系列產品使用帳號之軟體登錄時間、網路位址 (IP address) 等相關資訊。在任何情況下，系統若發現有多人登錄同一帳號情況， Becker Taiwan (捷進) 有權中止該帳號之軟體權限。</li>
                                </ul>
                                </li>

                                <li>
                                終止契約<br />
                                學員如有違反強制禁止規定或公序良俗之行為、或違反本契約經限期改正仍未改正者， Becker Taiwan (捷進) 得終止本契約，不得異議。如學員自行或因可歸責於己之事由終止契約者，教材一經領取或帳號登入後，恕不退費。
                                </li>

                                <li>賣方保留任何因賣方代理原廠停產因素而停止供貨的權利，賣方亦保留任何因賣方代理原廠更改貨品規格而更改之權利並對此不負擔責任。</li>

                                <li>捷進顧問有限公司 (Becker Taiwan) 已依照台北市短期補習班管理規則之規定立案登記，並已加入中華民國補教業品保協會辦理之補習服務聯合連帶保證協定 (品保協會會員編號：020267)。</li>

                                <li>
                                購買捷進顧問有限公司 (Becker Taiwan) 任一方案者，享有聯合服務連帶保證協定，如 Becker Taiwan (捷進) 因財務或其他原因等問題致其補習服務無法提供，學生得於地方主管機關認定其無法提供補習服務時起六個月內向加入本協定之性質相近之補習班 (以同一直轄市或縣市為原則) 換取等值之服務（但不包括原補習服務之贈品或贈送課程）；等值之服務除依一般方式授課外，得以多元之教學方式辦理。
                                </li>

                                <li>
                                隱私權聲明<br />
                                捷進顧問有限公司感謝您訂購 Becker 教材方案。本公司將依個人資料保護法第8條第1項之要求，向您告知以下事項：
                                <ul>
                                    <li>蒐集目的：依照101年10月1日修正之個人資料保護法之特定目的及個人資料之類別，040行銷、069契約、類似契約或其他法律關係事務、090消費者客戶管理與服務、157調查、統計與研究分析、181其他經營合於營業登記項目或組織章程所定之業務182其他諮詢與顧問服務。</li>
                                    <li>個人資料類別： C001電子郵件、中文姓名、英文拼音全名、電話號碼。C002金融機構帳戶號碼與姓名。C003身分證字號。C036是否曾訂購本公司產品、得知本公司之管道。C038在職身分C051所屬或畢業學校與科系。</li>
                                    <li>個人資料利用之期間、地區：我們會在您使用本公司提供服務之期間與地區利用您的個人資料。</li>
                                    <li>個人資料利用對象及方法：本公司將會依照您所填寫之訂購資料，確認您已完成訂購，並替您註冊帳號、寄送商品、提供學員管理、行銷活動等服務。並將分析您提供之類別C036、C038、C051等資訊，以增進本公司之服務。在未經您的同意下，我們不會將您的個人資料提供給第三人或做不當利用。</li>
                                    <li>如您所提供之個人資料不正確或不完整，可能將無法完整履行訂購單內容。</li>
                                    <li>您得行使個資法第3條所賦予之相關權利，如您欲行使該權利請來信 service@beckertw.com。</li>
                                </ul>
                                </li>
                            </ol>
                            </div>


                </p>

                <div className="text-center">
                    <label>
                    <input className="m-2" type="checkbox" value="read" checked={isChecked} onChange={handleCheckboxChange} required />
                    <span>我已詳閱並且了解</span>
                    </label>
                    <div className="btn btn-primary m-3" onClick={handleNextButtonClick}>下一步</div>
                </div>
                </div>
            </div>
            </div>
    );
}
